import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/img/icon-profile.png'


const _hoisted_1 = { class: "profile" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "مشخصات ادمین")
], -1)
const _hoisted_3 = { class: "information h-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "information__title" }, [
  /*#__PURE__*/_createTextVNode(" اطلاعات شخصی "),
  /*#__PURE__*/_createElementVNode("button", { class: "information__button" }, [
    /*#__PURE__*/_createTextVNode(" ویرایش"),
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pen m-1 p-2" })
  ])
], -1)
const _hoisted_5 = { class: "information__img row container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "profile"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<form><div class=\"row m-2\"><div class=\"col\"><input type=\"text\" class=\"form-control\" placeholder=\"سن\"></div><div class=\"col\"><input type=\"text\" class=\"form-control\" placeholder=\" شماره تماس\"></div><div class=\"col\"><input type=\"text\" class=\"form-control\" placeholder=\"کد ملی\"></div></div><div class=\"row mt-4 m-2\"><div class=\"col\"><input type=\"text\" class=\"form-control\" placeholder=\" ایمیل\"></div><div class=\"col\"><input type=\"text\" class=\"form-control\" placeholder=\" آدرس\"></div></div></form>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString(_ctx.first_name + " " + _ctx.last_name), 1)
      ]),
      _hoisted_7
    ])
  ]))
}